// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1":"c38b1ac2","135":"c94b94f3","168":"6d6dff21","491":"dd3465e5","516":"42b5886e","606":"fa1c73fb","785":"e3f8d43a","787":"c38b1ac2","898":"af8b570d","904":"5662a49e","961":"37fdaca1"}[chunkId] + ".chunk.css";
};